
import { Utils, moment, Comparator, Period } from 'revlock-webutils';
import { updateRatablePlan } from "./plan/ApportionedRatablePlan"
import { Codes } from "./ErrorCode";
import RecognitionRule from './reference/RecognitionRule';

export function updatePSPlan(revenueArrangementItem, salesOrder, errors, enableBetaFeatures) {

    let productRevenue = revenueArrangementItem.productRevenue

    if (salesOrder.revenueArrangement) {
        const currentRevenueArrangement = salesOrder.revenueArrangement.find(ra => ra.id == revenueArrangementItem.revenueArrangementId)

        if (currentRevenueArrangement.isRevenueDelayed) {
            // revenue needs to be delayed
            productRevenue = 0
        }
    }

    if (revenueArrangementItem.recognitionRule.id == RecognitionRule.PERCENT_OF_COMPLETE) {
        updatePSPlan_POC(revenueArrangementItem, salesOrder, errors, productRevenue);
    } else if (!enableBetaFeatures) {
        updatePSPlan_default(revenueArrangementItem, salesOrder, errors, productRevenue);
    } else {
        updatePSPlan_ProportionalPerformance(revenueArrangementItem, salesOrder, errors, productRevenue);
    }
}

const toPeriod = period => {
    if (!Utils.isValidPeriodFormat(period)) {
        return Utils.formatToAccountingPeriod(period)
    }

    return period;
}

export function getCommulativePSDByPeriod(deliveryLog) {
    const groupedByPeriod = Utils.groupByOnArray(deliveryLog, E => toPeriod(E.period));
    const psdLogs = []
    Object.keys(groupedByPeriod).forEach(period => {
        const psdLog = groupedByPeriod[period]
        const psd = {}
        Object.assign(psd, psdLog[0], { unitsDelivered: undefined, percentComplete: undefined })
        psdLog.forEach(log => {

            if (log['unitsDelivered']) {
                if (psd['unitsDelivered'] == undefined) {
                    psd['unitsDelivered'] = 0
                }
                psd['unitsDelivered'] += log['unitsDelivered']

            } else if (log['percentComplete']) {
                if (psd['percentComplete'] == undefined) {
                    psd['percentComplete'] = 0
                }
                psd['percentComplete'] += log['percentComplete']
            }
        })

        psdLogs.push(psd)
    })

    psdLogs.sort(function (log1, log2) {
        return moment(log1.period, Utils.PERIOD_FORMAT).diff(moment(log2.period, Utils.PERIOD_FORMAT))
    })

    return psdLogs
}

export function getDisabledPSDEntries(psdLogs) {
    const toReturn = []

    psdLogs.forEach(log => {
        if (log.disabled != undefined && log.disabled == true) {
            toReturn.push(log)
        }
    })

    toReturn.sort(function (log1, log2) {
        return moment(log1.period, Utils.PERIOD_FORMAT).diff(moment(log2.period, Utils.PERIOD_FORMAT))
    })

    return toReturn
}

export function preparePSDHours(psdLogs) {
    const disabledPSDEntries = getDisabledPSDEntries(psdLogs);
    let totalDisabledHours = 0
    let addDisabledHours = false
    if (disabledPSDEntries.length > 0) {
        const lastDisabledObject = disabledPSDEntries[disabledPSDEntries.length - 1]
        totalDisabledHours = lastDisabledObject.unitsDelivered
        addDisabledHours = true
    }

    let previousPSD = 0
    psdLogs.forEach((currentPsd, index) => {
        if (currentPsd['unitsDelivered'] != undefined && (currentPsd.disabled == undefined || currentPsd.disabled == false)) {
            if (addDisabledHours) {
                previousPSD += totalDisabledHours
                addDisabledHours = false
            }
            currentPsd['unitsDelivered'] += previousPSD
            previousPSD = currentPsd['unitsDelivered']
        }
    })
}

export function getDeliveryLogByPeriod(soiPSDelivery) {
    let deliveryLogByPeriod = undefined
    if (soiPSDelivery.isLegacy == undefined || soiPSDelivery.isLegacy == true) {
        deliveryLogByPeriod = Utils.arrayToObject(soiPSDelivery.deliveryLog, E => toPeriod(E.period));
    } else {
        const psdLogs = getCommulativePSDByPeriod(soiPSDelivery.deliveryLog)

        preparePSDHours(psdLogs)

        deliveryLogByPeriod = Utils.arrayToObject(psdLogs, E => toPeriod(E.period));
    }

    return deliveryLogByPeriod
}

export function updatePSPlan_default(revenueArrangementItem, salesOrder, errors, productRevenue) {
    let { professionalServiceDelivery } = salesOrder;

    if (professionalServiceDelivery) {
        let { salesOrderItem, plan } = revenueArrangementItem;
        let soiPSDelivery = professionalServiceDelivery.soiProfessionalServiceDelivery.find(psd => {
            let itemId = revenueArrangementItem.salesOrderItem.rootId || revenueArrangementItem.salesOrderItem.id
            if (psd.salesOrderItemId === itemId) return psd
        });

        if (soiPSDelivery) {
            let deliveryLogByPeriod = getDeliveryLogByPeriod(soiPSDelivery)

            let cummulativePercentRecognized = 0;
            let disabled = false
            for (let planElement of plan) {
                if (cummulativePercentRecognized == 1) {
                    // we have recognized everything 100%
                    break;
                }
                let deliveryLog = deliveryLogByPeriod[planElement.period];
                if (deliveryLog) {
                    let { unitsDelivered, percentComplete, hourlyRate } = deliveryLog;

                    if (percentComplete) {
                        percentComplete = Math.abs(percentComplete)
                    } else {
                        unitsDelivered = Math.abs(unitsDelivered)
                    }

                    if (percentComplete) {
                        planElement.percentRecognized = deliveryLog.percentComplete;
                        if (planElement.percentRecognized > 1) {
                            planElement.percentRecognized = 1
                            if (errors) {
                                errors.add(Codes.TRAN_25, {
                                    salesOrder, salesOrderItem,
                                    'unitsLogPosted': deliveryLog.percentComplete,
                                    'actualUnitsSold': 1,
                                    'period': deliveryLog.period,
                                    'extraUnits': deliveryLog.percentComplete - 1
                                });
                            }
                        }
                    } else {
                        if (unitsDelivered > salesOrderItem.quantity) {
                            if (errors) {
                                errors.add(Codes.TRAN_25, {
                                    salesOrder, salesOrderItem,
                                    'period': deliveryLog.period,
                                    'actualUnitsSold': salesOrderItem.quantity,
                                    'unitsLogPosted': unitsDelivered,
                                    'extraUnits': unitsDelivered - salesOrderItem.quantity,
                                });
                            }
                            unitsDelivered = salesOrderItem.quantity
                        }
                        planElement.percentRecognized = unitsDelivered / salesOrderItem.quantity
                    }

                    planElement.percentRecognized -= cummulativePercentRecognized;
                }

                cummulativePercentRecognized += planElement.percentRecognized;
            }

            updateRatablePlan(plan, productRevenue);
        }
    }
}

export function updatePSPlan_POC(revenueArrangementItem, salesOrder, errors, productRevenue) {
    let { professionalServiceDelivery } = salesOrder;

    if (professionalServiceDelivery) {
        let soiPSDelivery = professionalServiceDelivery.soiProfessionalServiceDelivery.find(psd => {
            let itemId = revenueArrangementItem.salesOrderItem.rootId || revenueArrangementItem.salesOrderItem.id
            if (psd.salesOrderItemId === itemId) return psd
        });

        if (soiPSDelivery) {
            let { salesOrderItem, plan: revenuePlan } = revenueArrangementItem;
            let { estimatedTotalCost, estimatedUnitCost } = salesOrderItem

            let { deliveryLog } = soiPSDelivery

            deliveryLog.forEach(log => {
                log.period = toPeriod(log.period)

                if (log.unitsDelivered) {
                    log.hourlyRate = estimatedUnitCost
                    log.costOfUnitsDelivered = log.unitsDelivered * estimatedUnitCost
                }
            })

            let groupedByPeriod = Utils.agg(deliveryLog, ['period'], ['period'], [], [], ['percentComplete', 'unitsDelivered', 'costIncurred', 'costOfUnitsDelivered']);
            let logsByPeriod = Utils.arrayToObject(groupedByPeriod, E => E.period);

            for (let planElement of revenuePlan) {
                let periodPSD = logsByPeriod[planElement['period']]
                if (!periodPSD) continue;

                planElement.percentRecognized = (periodPSD.costOfUnitsDelivered + periodPSD.costIncurred) / estimatedTotalCost;
            }

            updateRatablePlan(revenuePlan, productRevenue);
        }
    }
}

export function reversePS(salesOrder, referenceData) {

    let { professionalServiceDelivery } = salesOrder;

    if (professionalServiceDelivery) {
        const { organization } = referenceData

        if (professionalServiceDelivery.soiProfessionalServiceDelivery.length > 0) {

            professionalServiceDelivery.soiProfessionalServiceDelivery.forEach(soiPSDelivery => {
                const { deliveryLog, logMethod } = soiPSDelivery

                if (deliveryLog.length > 0) {
                    deliveryLog.forEach(log => {
                        const _log = Utils.cloneDeep(log)

                        if (!organization.isRestatementMode && _log.effectivePeriod < organization.currentPeriod) {
                            _log.effectivePeriod = organization.currentPeriod
                            _log.period = organization.currentPeriod

                            const openPeriod = organization.currentPeriod
                            let openPeriodStartOfMonth = Utils.startOfMonth(openPeriod, Utils.PERIOD_FORMAT)
                            _log.logDate = Utils.formatDate(openPeriodStartOfMonth)
                        }

                        if (logMethod === 'percentComplete') {
                            _log.percentComplete *= -1
                        } else {
                            _log.unitsDelivered *= -1
                        }

                        soiPSDelivery.deliveryLog.push(_log)
                    })
                }
            })
        }
    }

}

export function updatePSPlan_ProportionalPerformance(
    revenueArrangementItem, 
    salesOrder, 
    errors, 
    productRevenue
) {
    let { professionalServiceDelivery } = salesOrder;

    let terminatedProductRevenue = undefined
    let soiPSDelivery = undefined
    let cummulativePercentRecognized = 0

    if (professionalServiceDelivery) {
        soiPSDelivery = professionalServiceDelivery.soiProfessionalServiceDelivery.find(psd => {
            let itemId = revenueArrangementItem.salesOrderItem.rootId || revenueArrangementItem.salesOrderItem.id
            if (psd.salesOrderItemId === itemId) return psd
        });

        if (soiPSDelivery) {
            let { salesOrderItem, plan: revenuePlan } = revenueArrangementItem;
            let { salePrice, extendedSalePrice, quantity } = salesOrderItem

            let { deliveryLog } = soiPSDelivery

            // This revenue item has temination event associated, 
            // we discard delivery logs after temination.
            if (revenueArrangementItem.terminationDate) {
                let { terminationDate } = revenueArrangementItem;
                // Discard delivery logs after termination Date
                deliveryLog = deliveryLog.filter(log => Period.isSameOrAfter(terminationDate, log.logDate))
            }

            let firstPeriod = revenuePlan[0].period

            if (deliveryLog.length > 0) {
                let percentCompleteMethod = !Utils.isNumber(deliveryLog[0].unitsDelivered) && true || false

                soiPSDelivery.logMethod = percentCompleteMethod ? 'percentComplete' : 'unitsDelivered'

                if (percentCompleteMethod) {
                    let percentToDate = 0

                    deliveryLog = deliveryLog.sort(Comparator.getComparator(
                        ["logDate", 'timestamp'],
                        [Comparator.forType('date'), Comparator.forType('number')]
                    ))

                    deliveryLog.forEach(log => {
                        log.logPercentComplete = log.percentComplete - percentToDate;
                        log.billableAmount = extendedSalePrice * log.logPercentComplete

                        percentToDate = log.percentComplete

                        if (!log.effectivePeriod) {
                            if (log.period < firstPeriod) {
                                log.effectivePeriod = firstPeriod
                            } else {
                                log.effectivePeriod = log.period
                            }
                        }
                    })
                } else {
                    deliveryLog.forEach(log => {
                        log.hourlyRate = log.hourlyRate || salePrice;
                        log.billableAmount = log.unitsDelivered * log.hourlyRate;
                        if (!log.effectivePeriod) {
                            if (log.period < firstPeriod) {
                                log.effectivePeriod = firstPeriod
                            } else {
                                log.effectivePeriod = log.period
                            }
                        }
                    })
                }

                let groupedByPeriod = Utils.agg(deliveryLog, ['effectivePeriod'], ['effectivePeriod'], [], [], ['billableAmount', 'logPercentComplete', 'unitsDelivered']);
                let logsByPeriod = Utils.arrayToObject(groupedByPeriod, E => E.effectivePeriod);

                for (let planElement of revenuePlan) {
                    let periodPSD = logsByPeriod[planElement['period']]
                    if (!periodPSD) {
                        planElement.percentRecognized = 0
                        continue
                    };

                    if (soiPSDelivery.logMethod === 'unitsDelivered') {
                        planElement.percentRecognized = (periodPSD.unitsDelivered) / quantity;
                    } else {
                        planElement.percentRecognized = periodPSD.logPercentComplete
                    }

                    cummulativePercentRecognized += planElement.percentRecognized
                }

                if (revenueArrangementItem.terminationDate) {
                    // This item is terminated at this point.
                    // Amount that is recognized till termination date is considered to be 100% recognized.
                    revenuePlan.forEach(element => {
                        // For e.g 
                        // 202209 = 0.4 (40%) revenue and 202210 = 0.2 (20%) revenue, total revenue is 0.6 (60%)
                        // Changing to 
                        // 202209 = 0.4 / 0.6 = 0.666
                        // 202210 = 0.2 / 0.6 = 0.333
                        element.percentRecognized = element.percentRecognized / cummulativePercentRecognized
                    })

                    // Would only be the case when new arrangement is created.
                    if (!revenueArrangementItem.terminatedProductRevenue) {
                        revenueArrangementItem.terminatedProductRevenue = 
                            revenueArrangementItem.productRevenue * Math.min(cummulativePercentRecognized, 1)
                    }

                    // here product revenue is passed explictly to this function, so we infer terminatedProductRevenue
                    terminatedProductRevenue = productRevenue * Math.min(cummulativePercentRecognized, 1)

                    // When service log is received in an open period after termination period is closed.
                    // terminated revenue may increase or decrease.
                    if (terminatedProductRevenue) {
                        revenueArrangementItem.terminatedProductRevenue = terminatedProductRevenue
                    }
                }

                if (revenueArrangementItem.terminationDate) {
                    updateRatablePlan(revenuePlan, terminatedProductRevenue);
                } else {
                    updateRatablePlan(revenuePlan, productRevenue);
                }
            }
        }
    }
    
    // Termination date is present, but NO service is delivered,
    // We zero out the revenue plan in this case.
    if (!soiPSDelivery && revenueArrangementItem.terminationDate) {        	
		const zeroElement = {
			planAmount: 0,
			percentRecognized: 0,
			cummulativeTotal: 0,
			cummulativePercentRecognized: 0
		}
		revenueArrangementItem.plan.forEach(element => {
			Object.assign(element, zeroElement)
		})
    }

    return {
        cummulativePercentRecognized
    }

}

